module.exports = __webpack_public_path__ + "media/img/scholarship_types/Athletic Scholarships-d3f90186819d245f4cd8a3f853268770.svg";